const o = {
  name: "ThumbUp",
  dimensions: { width: 24, height: 24 },
  content: `
        <g fill="none" stroke="currentColor">
            <path d="M1 8.5V19.5H14.76C15.52 19.5 16.22 19.07 16.55 18.39L18.64 14.16C19.85 11.51 17.91 8.5 15 8.5H12L12.53 7.58C14.07 4.87 12.12 1.5 9 1.5L6.5195 7.28784C6.20434 8.02321 5.48126 8.5 4.68121 8.5H1Z" fill="none" strone="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/>
            <path d="M5 8.5V19.5" fill="none" strone="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/>
        </g>
    `
};
export {
  o as ThumbUp
};
